import React from "react";
import "./ChangePreviewModal.css";

const ChangePreviewModal = ({ changes, onConfirm, onCancel }) => {
  const renderNewEntries = () => {
    if (changes.insertedCount === 0) return <p>No new entries.</p>;
    return changes.inserted.map((entry, idx) => (
      <div key={idx} className="entry-block">
        <h4>🔹 Entry {idx + 1}</h4>
        <ul>
          {Object.entries(entry).map(([key, value]) => (
            <li key={key}><strong>{key}:</strong> {Array.isArray(value) ? value.join(", ") : value}</li>
          ))}
        </ul>
      </div>
    ));
  };

  const renderUpdatedEntries = () => {
    if (changes.updatedCount === 0) return <p>No updated entries.</p>;
    return changes.updated.map((entry, idx) => (
      <div key={idx} className="entry-block">
        <h4>✏️ Entry with Serial No: {entry.serialNo}</h4>
        <ul>
          {Object.entries(entry.changes).map(([key, value]) => (
            <li key={key}><strong>{key}:</strong> {Array.isArray(value) ? value.join(", ") : value}</li>
          ))}
        </ul>
      </div>
    ));
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>📋 Review Changes</h2>

        <h3>🆕 New Entries: {changes.insertedCount}</h3>
        {renderNewEntries()}

        <h3>✏️ Updated Entries: {changes.updatedCount}</h3>
        {renderUpdatedEntries()}

        <div className="modal-buttons">
          <button onClick={onConfirm} className="confirm-btn">✅ Confirm Upload</button>
          <button onClick={onCancel} className="cancel-btn">❌ Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ChangePreviewModal;
